import { createSlice } from '@reduxjs/toolkit';

const initialState = localStorage.getItem('planificacionDisplaySimbologiaRuta') !== 'false';

const planificacionDisplaySimbologiaRutaSlice = createSlice({
	name: 'planificacionDisplaySimbologiaRuta',
	initialState,
	reducers: {
		changedisplaySimbologia: (state, action) => {
			const hide = action.payload === false;
			if (hide) {
				localStorage.setItem('planificacionDisplaySimbologiaRuta', 'false');
			} else {
				localStorage.removeItem('planificacionDisplaySimbologiaRuta');
			}
			return action.payload; // <-- retorna el nuevo estado
		}
	}
});

export const { changedisplaySimbologia } = planificacionDisplaySimbologiaRutaSlice.actions;
export default planificacionDisplaySimbologiaRutaSlice.reducer;
